import styled, { css } from "styled-components/macro";
import { device } from "../../device";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;

  max-width: 500px;

  background: #ffffff;
  border: 1px solid #ebedee;
  border-radius: 8px;

  margin: 60px auto;

  @media ${device.tablet} {
    width: 100%;
    padding: 1rem;
    margin: 1rem auto;
    img {
      height: 150px;
    }
  }
`;
export const StyledDoThisLater = styled.p`
  &:hover {
    cursor: pointer;
  }
  text-decoration: none;

  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;

  color: #575e68;
  margin-top: 10px;
`;

export const IntContainer = styled(Container)`
  align-items: start;
  padding: 64px;
  max-width: 711px;
  form {
    font-size: 16px;
    line-height: 24px;
    color: #575e68;
    margin: 10px 0px;
    text-align: left;
  }
  @media ${device.tablet} {
    width: 100%;
    padding: 1.5rem;
    margin: 0.5rem auto;
  }
`;

export const StyledVideoContainer = styled.div`
  margin: auto;
  width: 100%;
`;
export const StyledVideo = styled.video`
  width: 100%;
  margin: auto;
`;
export const StyledGoBack = styled.div`
  &:hover {
    cursor: pointer;
  }
  display: flex;
  align-items: center;
  color: rgb(87, 94, 104, 0.5);
  font-size: 16px;
  line-height: 22px;

  svg {
    margin: 8px;
  }
`;

export const Title = styled.h3`
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  text-align: left;

  color: #575e68;

  margin: 16px 0;
  @media ${device.tablet} {
    font-size: 28px;
    line-height: 40px;
  }
`;
export const Code = styled.code`
  p {
    color: ${(props) => (props.textColor ? "#008060" : "#6270C6")};
    font-family: Poppins;
    font-size: 14px;
    text-align: center;
    margin-top: 10px;
    transition: font-size 0.1s ease-in-out, font-weight 0.1s ease-in-out;
  }
  width: 100%;
  white-space: pre-wrap;
  font-size: 10px;
  text-align: left;

  padding: 12px 20px;
  background: #f4f6f8;
  border: 1px solid #dddddd;
  border-radius: 4px;
  word-wrap: break-word;

  &:hover {
    cursor: pointer;
    p {
      font-size: 14px;
      font-weight: 600;
    }
  }
`;

export const Button = styled.button`
  &:hover {
    cursor: pointer;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }
  padding: 8px 12px;
  background: #6270c6;
  opacity: ${(props) => (props.disabled ? 0.2 : 1)};

  border: 1px solid #939dd6;
  border-radius: 4px;
  margin: 0 16px;

  color: #fcfcfd;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  width: 120px;
  @media ${device.tablet} {
    width: 80px;
    padding: 6px 10px;
  }
  @media ${device.mobileM} {
    font-size: 10px;
    width: 70px;
  }
`;
export const StyledPlatformsIntContainer = styled(IntContainer)`
  max-width: 530px;
  text-align: left;
`;

export const StyledPlatformsSubtitle = styled.p`
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  color: #575e68;
`;

export const StyledPlatformsList = styled.ul`
  list-style: none;

  display: flex;
  flex-direction: column;
  margin: 16px 0;

  li {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    align-self: stretch;
    margin: 8px 0;
  }
`;

export const StyledPlatformLabel = styled.p`
  font-size: 16px;
  line-height: 20px;
  color: #575e68;

  @media ${device.mobileL} {
    span {
      display: block;
    }
  }
`;

export const StyledToggleButton = styled(Button)`
  padding: 6px 8px;
  margin: 0;
  width: 40px;
  border: 1px solid rgb(87, 94, 104, 0.8);
  overflow: hidden;
  @media ${device.mobileL} {
    font-size: 12px;
    padding: 4px 8px;
  }
`;

export const StyledToggleButtonLeft = styled(StyledToggleButton)`
  border-radius: 4px 0 0 4px;
  border-right: none;
  ${(props) =>
    props.value
        ? css`
          background: #008060;
          &:hover {
            opacity: 0.9;
          }
        `
        : css`
          color: #575e68;
          background: #ffffff;
          &:hover {
            background: rgb(87, 94, 104, 0.1);
          }
        `}
`;
export const StyledToggleButtonRight = styled(StyledToggleButton)`
  border-radius: 0 4px 4px 0;
  border-left: none;
  ${(props) =>
    props.value
        ? css`
          background: rgb(87, 94, 104, 0.8);
          &:hover {
            opacity: 0.9;
          }
        `
        : css`
          color: #575e68;
          background: #ffffff;
          &:hover {
            background: rgb(87, 94, 104, 0.1);
          }
        `}
`;

export const Button3 = styled.button`
  display: block;
  opacity: ${(props) => (props.disabled ? 0.2 : 1)};

  margin: 0;
  &:hover {
    text-decoration: none;
    cursor: pointer;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }
  background: #6270c6;
  ${"" /* background: ${(props) => (props.disabled ? "#939DD6" : "#6270c6")}; */}
  padding: 10px 21px;
  border: 1px solid #939dd6;
  border-radius: 4px;

  color: #fcfcfd;
  font-style: normal;

  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
`;

export const Button2 = styled(Button)`
  &:hover {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }
  padding: 10px 21px;
  margin: 16px 0 0 0;
  font-size: 16px;
  opacity: ${(props) => (props.disabled ? 0.2 : 1)};
  display: block;
`;

export const Checklist = styled.ul`
  list-style: none;

  display: flex;
  flex-direction: column;
  align-items: start;

  margin: 32px auto;

  li,
  .tooltip {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    align-self: stretch;
    margin: 8px 0;
  }
  .tooltip {
    width: 100%;
  }
  @media ${device.tablet} {
    margin: 10px auto;
  }
`;

export const StyledListItem = styled.div`
  display: inline-block;
  display: flex;
  align-items: center;
  svg {
    font-size: 18px;
  }
`;

export const StyledLabel = styled.span`
  text-align: left;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 100%;
  color: #575e68;
  opacity: ${(props) => (props.checked ? 0.5 : 1)};
  margin-left: 16px;
  span {
    font-size: 12px;
    line-height: 18px;
  }
  @media ${device.tablet} {
    font-size: 14px;
  }
  @media ${device.mobileM} {
    font-size: 12px;
  }
`;

export const StyledP = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 25px;
  text-align: left;
  color: #575e68;

  margin-bottom: 16px;

  & span {
    font-weight: 600;
  }
`;
export const StyledSubTitle = styled.h4`
  text-align: left;
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #575e68;
  margin: 16px 0;
`;

export const StyledSelectOptions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  label {
    font-size: 14px;
    line-height: 21px;
    color: #575e68;
    padding-left: 16px;
    margin-bottom: 5px;
    span {
      color: #c64242;
    }
  }
  select {
    padding: 12px 16px;
    margin-bottom: 16px;
    width: 100%;
    ${"" /* appearance: none; */}
    option {
      font-size: 16px;
      line-height: 100%;
      color: #111111;
    }
  }
`;

export const StyledFBIntegrationForm = styled.form`
   width: 100%;
  .facebook-button {
    background: #1877f2;
    border: 1px solid #1877f2;
    border-radius: 4px;
    color: #fcfcfd;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    font-size: 16px;

    padding: 10px 21px;
    margin: 16px 0 0 0;
  }
  .facebook-button:hover {
    cursor: pointer;
  }
`;
export const StyledConnectFBBlock = styled.div`
  background: #f2f2f2;
  border-radius: 8px;
  padding: 1rem;
`;
export const StyledCheckboxInput = styled.div`
  padding: 1rem 0;
  font-size: 16px;
  line-height: 24px;
  label {
    margin-left: 10px;
  }
`;

export const StyledAu = styled.div`
	font-size: 14px;
	line-height: 21px;
	color: #575e68;

	display: flex;
	gap: 0.4rem;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;

	width: 100%;
	padding: 10px;

	background: #f4f6f8;
	border: 1px solid #ebedee;
	border-radius: 4px;
	input {
		font-size: 16px;
		line-height: 21px;
		border: 1px solid #dddddd;
		color: #111111;
		margin-right: 1rem;
		border-radius: 4px;
		padding: 0.2rem 0.4rem;
	}
	span {
		color: red;
		margin: 0 0.5rem;
	}
	svg {
		vertical-align: text-top;
	}
`;